type EditorProbeRecoilWrite = { t: number; keys: string[] }
type EditorProbeEvent = { t: number; name: string }

export type EditorProbeLog = {
  recoilWrites: EditorProbeRecoilWrite[]
  renders: Record<string, number>
  events: EditorProbeEvent[]
  reset: () => void
}

type EditorProbeWindow = Window & {
  __EDITOR_E2E_PROBE__?: boolean
  __editorProbe?: EditorProbeLog
}

export const EDITOR_PROBE_STORAGE_KEY = 'editorProbe'
export const EDITOR_PROBE_QUERY_PARAM = 'editorProbe'

const EVENT_LOG_CAP = 5_000

let armedForThisPageLoad: boolean | null = null

const readArmedFlag = (probeWindow: EditorProbeWindow): boolean => {
  if (probeWindow.__EDITOR_E2E_PROBE__ === true) return true
  try {
    if (probeWindow.localStorage?.getItem(EDITOR_PROBE_STORAGE_KEY) === '1')
      return true
  } catch {
    return false
  }
  return new RegExp(`[?&]${EDITOR_PROBE_QUERY_PARAM}=1(&|$)`).test(
    probeWindow.location?.search ?? '',
  )
}

const armedProbeWindow = (): EditorProbeWindow | null => {
  if (typeof window === 'undefined') return null
  const probeWindow = window as EditorProbeWindow
  if (armedForThisPageLoad === null)
    armedForThisPageLoad = readArmedFlag(probeWindow)
  return armedForThisPageLoad ? probeWindow : null
}

export const isEditorProbeArmed = (): boolean => armedProbeWindow() !== null

const emptyLog = (): EditorProbeLog => {
  const log: EditorProbeLog = {
    recoilWrites: [],
    renders: {},
    events: [],
    reset: () => {
      log.recoilWrites = []
      log.renders = {}
      log.events = []
    },
  }
  return log
}

const editorProbeLog = (): EditorProbeLog | null => {
  const probeWindow = armedProbeWindow()
  if (probeWindow === null) return null
  if (!probeWindow.__editorProbe) probeWindow.__editorProbe = emptyLog()
  return probeWindow.__editorProbe
}

export const countEditorProbeRender = (component: string): void => {
  const log = editorProbeLog()
  if (log === null) return
  log.renders[component] = (log.renders[component] ?? 0) + 1
  if (log.events.length < EVENT_LOG_CAP)
    log.events.push({ t: performance.now(), name: component })
}

export const recordEditorProbeRecoilWrite = (keys: readonly string[]): void => {
  const log = editorProbeLog()
  if (log === null || keys.length === 0) return
  log.recoilWrites.push({ t: performance.now(), keys: [...keys] })
}
